/**
 * Exhibits
 * --------
 */

if($('.exhibit-modal').length) {

    let modals = $('.modal'),
        exhibitNavLinks = $('.exhibit-navigation-item'),
        exhibitModal = $('#modal-exhibit'),
        exhibitModalOpens = $('.exhibit-modal-open-click'),
        currentExhibitIndex = 0,
        exhibitContentsItems = $('.exhibit-contents-item'),
        previousExhibitButton = $('.previous-exhibit-button'),
        nextExhibitButton = $('.next-exhibit-button'),
        exhibitMax = parseInt(window.exhibit_length),
        exhibitModalLeft = $('.exhibit-modal-left');

    exhibitModalOpens.on('click', function () {
        displayExhibit($(this).data('exhibit-index'));
    });

    previousExhibitButton.on('click', function () {
        let prevIndex = (currentExhibitIndex === 1) ? exhibitMax : currentExhibitIndex - 1;
        displayExhibit(prevIndex);
    });

    nextExhibitButton.on('click', function () {
        let nextIndex = (currentExhibitIndex === exhibitMax) ? 1 : currentExhibitIndex + 1;
        displayExhibit(nextIndex);
    });

    modals.on('show.bs.modal', function () {
        if($(this).hasClass('exhibit-modal')) {
            setTimeout(function () {
                $('.modal-backdrop').addClass('modal-backdrop-exhibit-popup');
            });
        } else {
            setTimeout(function () {
                $('.modal-backdrop').removeClass('modal-backdrop-exhibit-popup');
            });
        }

        // if($(this).hasClass('exhibit-video-modal')) {
        //     $('#')
        // }
    });

    modals.on('hidden.bs.modal', function () {
        if($(this).hasClass('exhibit-modal')) {
            window.history.replaceState('', '', updateURLParameter(window.location.href, "exhibit-id", ''));

            // setTimeout(function () {
            //     $('.modal-backdrop').removeClass('modal-backdrop-exhibit-popup');
            // });
        }

        if($(this).hasClass('exhibit-video-modal')) {

            let _this = $(this);

            setTimeout(function () {
                $('#modal-exhibit').modal('show');
                displayExhibit($('.exhibit-list-item[data-exhibit-id=' + _this.data('exhibit-id') + ']').data('exhibit-index'));
            }, 300);
        }
    });

    if(window.helpers.getQueryVariable('exhibit-id')) {
        $('.exhibit-list-item[data-exhibit-id="' + window.helpers.getQueryVariable('exhibit-id') + '"]').find('a').click();
    }

    exhibitModalLeft.on('click', function () {
        if($(this).hasClass('is-video-trigger')) {

            let _this = $(this);

            $('#modal-exhibit').modal('hide');

            setTimeout(function () {
                $('#exhibit-video-modal-' + _this.data('video-trigger-id')).modal('show');
            }, 100);

        }
    });

    function displayExhibit(index) {
        let backgroundImage = $('#exhibit-list-item-' + index).data('background-image'),
            exhibitId = $('#exhibit-list-item-' + index).data('exhibit-id'),
            exhibitContentItem = $('#exhibit-contents-item-' + index),
            exhibitListItem = $('#exhibit-list-item-' + index);

        exhibitModalLeft.attr('data-video-trigger-id', exhibitId);

        if(exhibitListItem.data('has-video')) {
            exhibitModalLeft.addClass('is-video-trigger');
        } else {
            exhibitModalLeft.removeClass('is-video-trigger');
        }

        currentExhibitIndex = index;

        window.history.replaceState('', '', updateURLParameter(window.location.href, "exhibit-id", exhibitId));

        $('html, body').animate({ scrollTop: ($('#exhibit-list-item-' + index).offset().top - 150) }, 500);

        exhibitModalLeft.addClass('hiding');

        setTimeout(function () {
            if(exhibitListItem.hasClass('exhibit-image-style-original')) {
                exhibitModalLeft.addClass('original-ratio');
            } else {
                exhibitModalLeft.removeClass('original-ratio');
            }

            exhibitModalLeft.css('background-image', 'url("' + backgroundImage + '")');
            exhibitModalLeft.find('img').attr('src', backgroundImage);
        }, 300);

        setTimeout(function () {
            exhibitModalLeft.removeClass('hiding');
        }, 600);

        exhibitContentsItems.not(exhibitContentItem).addClass('hiding');
        setTimeout(function () {
            exhibitContentsItems.not(exhibitContentItem).addClass('d-none');
            exhibitContentItem.removeClass('d-none');
        }, 300);
        setTimeout(function () {
            exhibitContentItem.removeClass('hiding');
        }, 305);
    }

}


function updateURLParameter(url, param, paramVal)
{
    var TheAnchor = null;
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = "";

    if (additionalURL)
    {
        var tmpAnchor = additionalURL.split("#");
        var TheParams = tmpAnchor[0];
        TheAnchor = tmpAnchor[1];
        if(TheAnchor)
            additionalURL = TheParams;

        tempArray = additionalURL.split("&");

        for (var i=0; i<tempArray.length; i++)
        {
            if(tempArray[i].split('=')[0] != param)
            {
                newAdditionalURL += temp + tempArray[i];
                temp = "&";
            }
        }
    }
    else
    {
        var tmpAnchor = baseURL.split("#");
        var TheParams = tmpAnchor[0];
        TheAnchor  = tmpAnchor[1];

        if(TheParams)
            baseURL = TheParams;
    }

    if(TheAnchor)
        paramVal += "#" + TheAnchor;

    var rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
}